import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-lg mx-auto text-left p-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mb-2 font-londrina" }, "Official Goods Shop", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-2 mb-8 font-pt-root font-medium" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Official goods are available "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://suzuri.jp/nounsfes",
      class: "underline font-londrina"
    }, "here"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mb-2 font-yusei" }, "公式グッズショップ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-2 mb-8" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("公式グッズはSUZURIの"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://suzuri.jp/nounsfes",
      class: "underline font-londrina"
    }, "Official Goods Shop"),
    /*#__PURE__*/_createTextVNode("で購入することができます。")
  ])
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.lang === 'en')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
  ]))
}